// Single source of truth for the Le Cercle professional categories.
// Used both by the admin profile editor (to tag each member) and by
// the public page (to filter the directory). The canonical string
// stored in MongoDB is the English value below.
export const CIRCLE_CATEGORIES = [
  'Construction & Trades',
  'Real Estate',
  'Architecture & Interior Design',
  'Beauty & Grooming',
  'Fashion & Apparel',
  'Restaurants & Hospitality',
  'Food & Culinary Arts',
  'Fitness & Performance',
  'Health & Medicine',
  'Law & Legal Services',
  'Finance & Investment',
  'Technology & Innovation',
  'Entrepreneurship & Business',
  'Creative Arts & Design',
  'Photography & Film',
  'Music & Entertainment',
  'Sports & Athletics',
  'Marketing & Communications',
  'Education & Mentorship',
];

// French display labels — keyed by the canonical English string above.
export const CIRCLE_CATEGORIES_FR = {
  'Construction & Trades': 'Construction & Métiers',
  'Real Estate': 'Immobilier',
  'Architecture & Interior Design': 'Architecture & Design intérieur',
  'Beauty & Grooming': 'Beauté & Soins',
  'Fashion & Apparel': 'Mode & Vêtements',
  'Restaurants & Hospitality': 'Restauration & Hospitalité',
  'Food & Culinary Arts': 'Arts culinaires',
  'Fitness & Performance': 'Fitness & Performance',
  'Health & Medicine': 'Santé & Médecine',
  'Law & Legal Services': 'Droit & Services juridiques',
  'Finance & Investment': 'Finance & Investissement',
  'Technology & Innovation': 'Technologie & Innovation',
  'Entrepreneurship & Business': 'Entrepreneuriat & Affaires',
  'Creative Arts & Design': 'Arts créatifs & Design',
  'Photography & Film': 'Photographie & Cinéma',
  'Music & Entertainment': 'Musique & Divertissement',
  'Sports & Athletics': 'Sports & Athlétisme',
  'Marketing & Communications': 'Marketing & Communications',
  'Education & Mentorship': 'Éducation & Mentorat',
};

export const categoryLabel = (cat, lang = 'en') =>
  lang === 'fr' ? (CIRCLE_CATEGORIES_FR[cat] || cat) : (cat || '');
